<template>
  <div v-if="supplyData.length" class="card">
    <div class="card-header">
      <div>补充证据</div>
    </div>
    <div class="card-body" v-for="(item,index) in supplyData" :key="index">
        <z-row>
        <z-col span='5'>补充时间</z-col>
        <z-col span='19'>{{item.time}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>补充描述</z-col>
        <z-col span='19'>{{item.content}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>截图凭证</z-col>
        <z-col span='19'>
          <ImageList :infoList="getpics(item.pics)"></ImageList>
        </z-col>
      </z-row>
    </div>
  </div>
</template>

<script>
import { Row, Col } from '@zz-common/zz-ui';
import ImageList from '../ImageList'
export default {
  name: 'SupplyCard',
  props: {
    infoData: {
      default: () => {}
    }
  },
  components: {
    'z-row': Row,
    'z-col': Col,
    ImageList
  },
  data() {
    return {
      type: {
        1: '商品',
        2: '私信',
        3: '订单',
        4: '其他',
        5: '视频',
        6: '图片',
        7: '短视频',
        8: 'url',
        9: '帖子',
        11: '直播'
      }
    }
  },
  computed: {
    supplyData() {
      return this.infoData.supplementList || []
    }
  },
  methods: {
    getpics(pics) {
      if (pics === '' || pics === ',') return []
      let res = []
      try {
        res = JSON.parse(pics)
      } catch {
        res = []
      }
      return res
    }
  }

}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>